import { DateTime } from "luxon"

import type { Trip } from "../types/logisticsTypes.ts"

export const getTripsEfficiency = (trips: Trip[]): number => {
  const { hours, target } = trips.reduce(
    (a, c) => {
      const hours = c.start
        ? DateTime.fromISO(c.end || "")
            .diff(DateTime.fromISO(c.start), "hours")
            .toObject().hours
        : 0

      const target = 0

      if (hours === undefined || hours > 5) {
        return {
          hours: a.hours,
          target: a.target,
        }
      }

      return {
        hours: a.hours + (hours || 0),
        target: a.target + target,
      }
    },
    {
      hours: 0,
      target: 0,
    },
  )

  return target == 0 ? 0 : 100 * (1 - (hours - target) / target)
}
